"use client";

import { getGetUnreadCountQueryKey, useGetUnreadCount } from "@/lib/api/generated";

export const UNREAD_COUNT_KEY = getGetUnreadCountQueryKey();

export function useUnreadCount() {
  return useGetUnreadCount({
    query: {
      staleTime: 30_000,
      refetchInterval: 60_000,
    },
  });
}
